// extracted by mini-css-extract-plugin
export default {"container":"LaunchKeyboardShortcutBanner_container__EYbU4","text":"LaunchKeyboardShortcutBanner_text__x-4mo"};